export default "__VITE_ASSET__CP$DKqTh__"